﻿import { nsMatrix } from "@/Namespaces";
import { RowServiceColumnItem } from "@/ServerTypes/RowServiceColumnItem";
import { ComboboxEditor, ComboboxEditorOptions, EditorProps, getRemoteData } from "@serenity-is/corelib";

export class ServiceSelectEditor extends ComboboxEditor<any, any> {
    static override[Symbol.typeInfo] = this.registerEditor(nsMatrix);

    constructor(opt: EditorProps<ComboboxEditorOptions>) {
        super({...opt, autoComplete: true });

        const data = (getRemoteData("RowServiceColumnData") as RowServiceColumnItem[]);

        const addedServices = new Set<string>();
        for (const item of data) {
            for (const service of item.Services)
            {
                if (addedServices.has(service))
                    continue;

                addedServices.add(service);
                this.addOption(service, service);
            }
        }
    }
}